import ButtonCount from "../../../components/ButtonCount/ButtonCount";
import { useEffect, useState } from "react";
import useStyles from "../styles";
import useValidator from "../../../hooks/useValidator";
import Button from "../../../components/Button/Button";
import Modal from "../../../components/Modal";
import { TableSearch } from "../../../components/Table/TableActions";
import Table from "../../../components/Table/Table";
import { Grid } from "@mui/material";
import Badge from "../../../components/Badge/Badge";
import { Icon } from "@iconify/react";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { ToastContainer, toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";

const GET_ALL_SCHOOL_PLAN = "/admin/v1/school-plans";
const GET_ALL_SESSIONS = "/admin/v1/sessions";
const GET_ALL_SCHOOL_TERMS = "/admin/v1/terms";
const GET_SCHOOL_PLAN_ID = "/admin/v1/school-plan";

// Dummy Data
import { Access } from "../../../utils/DropDown";
import { httprequest } from "../../../data/api";
import useWindowSize from "../../../hooks/useWindow";

const SchoolPlans = () => {
  // const navigate = useNavigate();
  const classes = useStyles();
  const { id } = useParams();
  const navigate = useNavigate();
  const [currentRow, setCurrentRow] = useState({});
  const [searchResult, setSearchResult] = useState([]);
  const [editPlanModal, setEditPlanModal] = useState(false);
  const [deletePlanModal, setDeletePlanModal] = useState(false);
  // FOR API ENDPOINT
  const [planValidator, showPlanValidator] = useValidator();
  const [planisfetching, setPlanIsFetching] = useState(false);
  const [schoolplanData, setSchoolPlanData] = useState([]);
  const [sessiondata, setSessionData] = useState([]);
  const [termdata, setTermData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [schoolplanModal, setSchoolPlanModal] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [editPlanValidator, showEditPlanValidator] = useValidator();

  const [schoolPlan, setSchoolPlan] = useState({
    title: "",
    term: "",
    session: "",
    start_date: "",
    end_date: "",
    description: "",
    access: []
  });
  const [editPlan, setEditPlan] = useState({
    title: "",
    term: "",
    session: "",
    start_date: "",
    end_date: "",
    description: "",
    access: []
  });

  const handleEditPlanModal = (row) => {
    setCurrentRow(row);
    setEditPlan({
      ...editPlan,
      title: row?.title,
      term: row?.term_id,
      session: row?.session_id,
      start_date: row?.start_date,
      end_date: row?.end_date,
      description: row?.description
    });
    setEditPlanModal(true);
  };

  const handleCloseEditPlanModal = () => {
    setCurrentRow({});
    setEditPlan({
      ...editPlan,
      title: "",
      term: "",
      session: "",
      start_date: "",
      end_date: "",
      description: ""
    });
    setEditPlanModal(false);
  };

  const handleDeleteModal = (row) => {
    setDeletePlanModal(true);
    setCurrentRow(row);
  };

  const handleCloseDeleteModal = () => {
    setDeletePlanModal(false);
    setCurrentRow({});
  };

  const handleSchoolPlanModal = () => {
    setSchoolPlanModal(true);
  };

  const handleCloseSchoolPlanModal = () => {
    setSchoolPlanModal(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSchoolPlan({ ...schoolPlan, [name]: value });
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditPlan({ ...editPlan, [name]: value });
  };

  const getAllSchoolPlans = () => {
    setPlanIsFetching(true);
    httprequest.get(`${GET_ALL_SCHOOL_PLAN}/${id}`).then((res) => {
      // eslint-disable-next-line no-console
      console.log(res?.data);
      setPlanIsFetching(false);

      setSchoolPlanData(res?.data?.data);
      setSearchResult(res?.data?.data);
    }).catch((err) => {
      setPlanIsFetching(false);
      toast.error(err?.response?.data);
    });
  };
  // eslint-disable-next-line no-console
  console.log(schoolplanData);

  const getAllSchoolSessions = () => {
    httprequest.get(`${GET_ALL_SESSIONS}/${id}`).then((res) => {
      // eslint-disable-next-line no-console
      console.log(res?.data?.data);
      setSessionData(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };
  // eslint-disable-next-line no-console
  console.log(sessiondata);

  const getAllSchoolTerms = () => {
    httprequest.get(`${GET_ALL_SCHOOL_TERMS}/${id}`).then((res) => {
      // eslint-disable-next-line no-console
      console.log(res?.data?.data);
      setTermData(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };
  // eslint-disable-next-line no-console
  console.log(termdata);

  // CREATE SCHOOL PLAN
  const handleCreatePlan = () => {
    if (planValidator.allValid()) {
      setIsLoading(true);
      httprequest
        .post(`${GET_SCHOOL_PLAN_ID}/${id}`, schoolPlan)
        .then((res) => {
          setIsLoading(false);
          toast.success(res?.data?.message);
          getAllSchoolPlans();
          setSchoolPlan({
            ...schoolPlan,
            term: "",
            session: "",
            start_date: "",
            end_date: "",
            description: "",
            access: []
          });
          handleCloseSchoolPlanModal();
        })
        .catch((err) => {
          setIsLoading(false);
          toast.error(err?.response?.data);
        });
    } else {
      showPlanValidator(true);
    }
  };

  const handleDeletePlan = () => {
    setIsDeleteLoading(true);
    httprequest
      .delete(`${GET_SCHOOL_PLAN_ID}/${currentRow?.id}`)
      .then((res) => {
        setIsDeleteLoading(false);
        toast.success(res?.data?.message);
        getAllSchoolPlans();
        handleCloseDeleteModal();
      })
      .catch((err) => {
        setIsDeleteLoading(false);
        toast.error(err?.response?.data);
      });
  };

  // --| Edit Plan API Call
  const handleEditPlan = () => {
    if (editPlanValidator.allValid()) {
      setIsEditLoading(true);
      httprequest
        .patch(`${GET_SCHOOL_PLAN_ID}/${currentRow?.id}`, editPlan)
        .then((res) => {
          setIsEditLoading(false);
          toast.success(res?.data?.message);
          getAllSchoolPlans();
          setEditPlan({
            ...schoolPlan,
            term: "",
            session: "",
            start_date: "",
            end_date: "",
            description: "",
            access: []
          });
          handleCloseEditPlanModal();
        })
        .catch((err) => {
          setIsEditLoading(false);
          toast.error(err?.response?.data);
        });
    } else {
      showEditPlanValidator(true);
    }
  };

  useEffect(() => {
    getAllSchoolPlans();
    getAllSchoolSessions();
    getAllSchoolTerms();
  }, []);

  const width = useWindowSize();
  const mobile = width < 550;

  const columns = [
    {
      name: "Title",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Title</p>}
          {String(row?.title || "N/A")}
        </>
      )
    },
    {
      name: "Access",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Access</p>}
          {Array.isArray(row?.access)
            ? row.access.map((accessItem) => accessItem.name).join(", ")
            : "N/A"}
        </>
      )
    },
    {
      name: "Description",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Description</p>}
          {String(row?.description || "N/A")}
        </>
      )
    },
    {
      name: "Created At",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Created At</p>}
          {row?.created_at ? row.created_at.substring(0, 10) : "N/A"}
        </>
      )
    },
    {
      name: "Status",
      center: true,
      cell: (row) => <Badge status={row?.status || ""} />
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button className="table-action-icon">
            <Icon icon="fluent:eye-16-regular" />
          </button>
          <button
            className="table-action-icon"
            onClick={() => handleEditPlanModal(row)}
          >
            <Icon icon="heroicons:pencil-square-solid" />
          </button>
          <button
            onClick={() => handleDeleteModal(row)}
            className="table-action-icon delete-icon"
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  // --| Filter School Plan table using name, email and class
  const handleSearchPlan = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = schoolplanData?.filter((data) => valArray?.every(
      (word) => data?.title?.toLowerCase().includes(word.toLowerCase()) ||
          data?.description?.toLowerCase().includes(word.toLowerCase()) ||
          data?.access?.toLowerCase().includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  const handleAccessChange = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions, (option) => option.value);
    setSchoolPlan((prevPlan) => ({
      ...prevPlan,
      access: selectedOptions  // Set access as an array of selected values
    }));
  };

  const { title, session, term, access, description, end_date, start_date } =
    schoolPlan;

  return (
    <div className={classes.pageContent}>
      <div className="flex justify-items-space padding-right">
        <div className="button-count-container flex gap-5">
          <ButtonCount title="School Sessions" func={() => navigate(`/schools/sessions/${id}`)} count={sessiondata?.length} />
          <ButtonCount title="School Terms" count={termdata?.length} func={() => navigate(`/schools/terms/${id}`)} />
        </div>
        <div className="flex gap-10">
          {/* <Button
            onClick={handleCreateSesion}
            variant="primaryoutline"
            buttonSize="fluid"
            color="btnfontprimary"
            buttonName="Create Session"
          /> */}
          <Button
            variant="primary"
            onClick={handleSchoolPlanModal}
            buttonSize="fluid"
            color="btndefault"
            buttonName="Create school Plans"
          />
        </div>
      </div>
      <Table
        data={searchResult}
        columns={columns}
        subHeader={true}
        pagination
        isLoading={planisfetching}
        subHeaderComponent={
          <TableSearch
            placeholder="Search here..."
            searchTableFunc={handleSearchPlan}
          />
        }
      />
      {/* Create School Plan */}
      <Modal
        title="Create a Student Plan"
        subtitle={<div>Create a new school plan for your school.</div>}
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Title"
                  margin="normal"
                  placeHolder="Enter title"
                  inputType="text"
                  onChange={handleChange}
                  inputName="title"
                  value={title}
                />
                {planValidator.message("Title", title, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup
                  label="Select Session"
                  children={
                    <select
                      onChange={handleChange}
                      name="session"
                      value={session}
                    >
                      <option value="">---Select---</option>
                      {sessiondata?.map((sesh) => {
                        return (
                          <option key={sesh?.id} value={sesh?.id}>
                            {sesh?.session}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
                {planValidator.message("Session", session, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup
                  label="Select Term"
                  children={
                    <select onChange={handleChange} name="term" value={term}>
                      <option value="">---Select---</option>
                      {termdata?.map((data) => {
                        return (
                          <option key={data?.id} value={data?.id}>
                            {data?.term}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
                {planValidator.message("Term", term, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Start Date"
                  margin="normal"
                  inputType="date"
                  onChange={handleChange}
                  inputName="start_date"
                  value={start_date}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="End Date"
                  margin="normal"
                  inputType="date"
                  onChange={handleChange}
                  inputName="end_date"
                  value={end_date}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup
                  label="Access"
                  children={
                    <select
                      name="access"
                      value={access}
                      onChange={handleAccessChange}
                    >
                      <option value="">---Select Access ---</option>
                      {Access?.map((staff) => {
                        return (
                          <option key={staff?.key} value={staff?.value}>
                            {staff?.text}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
                {planValidator.message("Access", access, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Description"
                  margin="normal"
                  inputType="text"
                  onChange={handleChange}
                  inputName="description"
                  value={description}
                />
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <>
            <div className={classes.modalFooterBtn}>
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName="Create School Plan"
                onClick={handleCreatePlan}
                isLoading={isLoading}
              />
            </div>
          </>
        }
        isopen={schoolplanModal}
        closeModal={handleCloseSchoolPlanModal}
      />

      {/* Edit School Plan */}
      <Modal
        title="Edit a Student Plan"
        subtitle={<div>Edit the current school plan for your school.</div>}
        modalContent={
          <>
            <Grid container spacing={2} className="input-padding">
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Title"
                  margin="normal"
                  placeHolder="Enter title"
                  inputType="text"
                  onChange={handleEditChange}
                  inputName="title"
                  defaultValue={editPlan?.title}
                />
                {editPlanValidator.message("Title", editPlan?.title, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup
                  label="Select Session"
                  children={
                    <select
                      onChange={handleEditChange}
                      name="session"
                      defaultValue={editPlan?.session}
                    >
                      <option value="">---Select---</option>
                      {sessiondata?.map((sesh) => {
                        return (
                          <option key={sesh?.id} value={sesh?.id}>
                            {sesh?.session}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
                {editPlanValidator.message("Session", editPlan?.session, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup
                  label="Select Term"
                  children={
                    <select
                      onChange={handleEditChange}
                      name="term"
                      defaultValue={editPlan?.term}
                    >
                      <option value="">---Select---</option>
                      {termdata?.map((data) => {
                        return (
                          <option key={data?.id} value={data?.id}>
                            {data?.term}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
                {editPlanValidator.message("Term", editPlan?.term, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Start Date"
                  margin="normal"
                  inputType="date"
                  onChange={handleEditChange}
                  inputName="start_date"
                  defaultValue={editPlan?.start_date?.substring(0, 10)}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="End Date"
                  margin="normal"
                  inputType="date"
                  onChange={handleEditChange}
                  inputName="end_date"
                  defaultValue={editPlan?.end_date?.substring(0, 10)}
                />
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <SelectGroup
                  label="Access"
                  children={
                    <select
                      name="access"
                      defaultValue={editPlan?.access}
                      onChange={handleEditChange}
                    >
                      <option value="">---Select Access ---</option>
                      {Access?.map((role) => {
                        return (
                          <option key={role?.key} value={role?.key}>
                            {role?.text}
                          </option>
                        );
                      })}
                    </select>
                  }
                />
                {editPlanValidator.message("Access", editPlan?.access, "required")}
              </Grid>
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <InputGroup
                  label="Description"
                  margin="normal"
                  inputType="text"
                  onChange={handleEditChange}
                  inputName="description"
                  value={editPlan?.description}
                />
              </Grid>
            </Grid>
          </>
        }
        modalFooter={
          <>
            <div className={classes.modalFooterBtn}>
              <Button
                variant="primary"
                buttonSize="full"
                color="btndefault"
                buttonName="Edit School Plan"
                onClick={handleEditPlan}
                isLoading={isEditLoading}
              />
            </div>
          </>
        }
        isopen={editPlanModal}
        closeModal={handleCloseEditPlanModal}
      />

      {/* Delete Modal */}

      <Modal
        title="Delete Current School Plan"
        subtitle={`Are you sure you want to delete this  ${currentRow?.title} ?. If you delete it, it becomes unavaiable for the whole school.`}
        modalContent={
          <>
            <div></div>
          </>
        }
        modalFooter={
          <>
            <Button
              type="submit"
              variant="danger"
              buttonName="Delete Selected School Plan"
              buttonSize="full"
              color="btndefault"
              onClick={handleDeletePlan}
              isLoading={isDeleteLoading}
            />
          </>
        }
        isopen={deletePlanModal}
        closeModal={handleCloseDeleteModal}
      />
      <ToastContainer />
    </div>
  );
};

export default SchoolPlans;
